import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Wrench } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// Top-level guard: when maintenance_mode is on, non-admin visitors see a
// maintenance page. Admins and the sign-in route are always allowed through.
const ALLOWED_PATHS = ["/signin", "/oauth/callback"];

const MaintenanceGate = ({ children }) => {
  const [maintenance, setMaintenance] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const { user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    let active = true;
    api.get("/settings")
      .then(({ data }) => { if (active) setMaintenance(!!data?.features?.maintenance_mode); })
      .catch(() => {})
      .finally(() => { if (active) setLoaded(true); });
    return () => { active = false; };
  }, [location.pathname]);

  const isAdmin = user?.role === "admin";
  const allowed = ALLOWED_PATHS.includes(location.pathname);

  if (loaded && maintenance && !isAdmin && !allowed) {
    return (
      <div className="min-h-screen bg-[#0D0D0D] flex flex-col items-center justify-center px-6 text-center" data-testid="maintenance-page">
        <div className="w-16 h-16 rounded-2xl bg-[#FF5C00]/12 flex items-center justify-center">
          <Wrench size={30} className="text-[#FF5C00]" />
        </div>
        <h1 className="text-[30px] font-bold text-white mt-6">Platform under maintenance</h1>
        <p className="text-neutral-400 mt-3 max-w-[440px]">We're making some improvements and will be back shortly. Thanks for your patience.</p>
      </div>
    );
  }
  return children;
};

export default MaintenanceGate;
